/* ============================================================================
   <footer-accordion>
   - Mobile (< 750 px): tap heading to expand/collapse the block.
   - Desktop (≥ 750 px): content is always visible (CSS forces it open),
     so the JS toggle is essentially inert until the viewport shrinks.
   ============================================================================ */
(function () {
  'use strict';

  if (customElements.get('footer-accordion')) return;

  const MOBILE_QUERY = '(max-width: 749px)';

  class FooterAccordion extends HTMLElement {
    constructor() {
      super();
      this.toggleBtn = null;
      this.content = null;
      this.mql = null;
      this.onClick = this.onClick.bind(this);
      this.onMQ = this.onMQ.bind(this);
    }

    connectedCallback() {
      this.toggleBtn = this.querySelector('[data-clf-toggle]');
      this.content = this.querySelector('[data-clf-content]');
      if (!this.toggleBtn || !this.content) return;

      this.toggleBtn.addEventListener('click', this.onClick);

      this.mql = window.matchMedia(MOBILE_QUERY);
      this.syncStateForViewport();
      // Re-sync when the viewport crosses the breakpoint
      if (typeof this.mql.addEventListener === 'function') {
        this.mql.addEventListener('change', this.onMQ);
      } else if (typeof this.mql.addListener === 'function') {
        this.mql.addListener(this.onMQ);
      }
    }

    disconnectedCallback() {
      this.toggleBtn && this.toggleBtn.removeEventListener('click', this.onClick);
      if (this.mql) {
        if (typeof this.mql.removeEventListener === 'function') {
          this.mql.removeEventListener('change', this.onMQ);
        } else if (typeof this.mql.removeListener === 'function') {
          this.mql.removeListener(this.onMQ);
        }
      }
    }

    onClick(e) {
      // Only react to clicks when on mobile — on desktop the heading is non-interactive.
      if (!this.mql || !this.mql.matches) return;
      e.preventDefault();
      this.toggle();
    }

    onMQ() {
      this.syncStateForViewport();
    }

    syncStateForViewport() {
      // Mobile starts collapsed; desktop is always open.
      if (this.mql.matches) {
        this.removeAttribute('open');
        this.toggleBtn.setAttribute('aria-expanded', 'false');
      } else {
        this.setAttribute('open', '');
        this.toggleBtn.setAttribute('aria-expanded', 'true');
      }
    }

    toggle() {
      const isOpen = this.hasAttribute('open');
      if (isOpen) {
        this.removeAttribute('open');
        this.toggleBtn.setAttribute('aria-expanded', 'false');
      } else {
        this.setAttribute('open', '');
        this.toggleBtn.setAttribute('aria-expanded', 'true');
      }
    }
  }

  customElements.define('footer-accordion', FooterAccordion);
})();
